import { useDispatch } from "react-redux";
import { buyTrade } from "../../redux/action/orderActions";
import React, { useState } from 'react';
import Button from '@material-ui/core/Button';
import CssBaseline from '@material-ui/core/CssBaseline';
import TextField from '@material-ui/core/TextField';
import ButtonGroup from '@material-ui/core/ButtonGroup';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import { makeStyles } from '@material-ui/core/styles';
import Container from '@material-ui/core/Container';
import { converttonumber } from "../../utils/stringtonumber";

const useStyles = makeStyles(theme => ({
  '@global': {
    body: {
      backgroundColor: theme.palette.common.white,
    },
  },
  paper: {
    marginTop: theme.spacing(0),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    
  },
  avatar: {
    margin: theme.spacing(1),
    backgroundColor: theme.palette.secondary.main,
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));



export const Buy = ({user, instrument, setOpen}) =>{
let {symbol, lastPrice, companyName} = instrument;
if(typeof +lastPrice !== Number )lastPrice = converttonumber(lastPrice)
const [quantity, setQuantity] = useState(0);
const dispatch = useDispatch();
const handleBuy = $ =>{
    const payload = {
         instrumentData: {
                instrument: symbol,
                price:  +lastPrice,
                quantity: +quantity
         },
         user
    }
    dispatch(buyTrade(payload))
    setOpen(false)
}

 const handleClick=(percent)=>{
      setQuantity(Math.round((percent/100)*quantity));
  }
  const onChange = (e)=>{

    setQuantity(e.target.value);

  }

    const classes = useStyles;
    return (
      <div>
     
  
  <Container component="main" maxWidth="xs">
    <CssBaseline />
    <div style={{ 
          position: "absolute",
          justifyContent: "center", 
          alignItem:"center",
          width: "500px",
          top: "20%",
          border: "2px solid black",
          padding: "30px",
          backgroundColor: "white"
    }} className={classes.paper}>
  
      <Typography component="h1" variant="h5">
       Buy {companyName} 
      </Typography>
      <form className={classes.form} noValidate>
        <TextField
          variant='filled'
          margin="normal"
          required
          fullWidth
          label="Price(Per Share)"     
          value={'Rs '+  lastPrice}
          
        />
               <TextField
          variant='filled'
          margin="normal"
          required
          fullWidth
          id="total"
          label="Total(In INR)"
          name="total"
          value={'Rs '+( lastPrice*quantity).toFixed(2)}
          
        />

  
        <TextField
          variant="outlined"
          margin="normal"
          required
          fullWidth
          name="quantity"
          label="Quantity"
          placeholder='Enter Shares'
          value={quantity}
          onChange={onChange}
        />
  
  <Grid item xs={12} md={6}>
      <Grid container spacing={5 } direction="column" alignItems="center">
    
        <Grid item>
          <ButtonGroup
            variant="outlined"
            color="primary"
            aria-label="full-width contained primary button group"
          >
            <Button onClick={()=>handleClick(25)} >25%</Button>
            <Button onClick={()=>handleClick(50)}>50%</Button>
            <Button onClick={()=>handleClick(75)}>75%</Button>
            <Button onClick={()=>handleClick(100)}>100%</Button>
          </ButtonGroup>
        </Grid>
       
      </Grid>
    </Grid>
      <br/>
        <Button
      
         halfwidth="true"
          variant="contained"
          color="primary"
          className={classes.submit}
          onClick = {()=>handleBuy()}
        >
          Buy
        </Button>  &nbsp;&nbsp;
        <Button
      
          halfwidth="true"
          variant="contained"
          color="secondary"
          className={classes.submit}
          onClick = {()=>setOpen(false)}
        >
         Cancel
        </Button>
      
      </form>
    </div>
   
  </Container>
      </div>
    );
  }


